import { rootApi } from "../../api/rootApi";

export const communityApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchAllCommunity: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/community/post/allPost`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    fetchCommunityCategory: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: `/tenant/community/category`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          }
        };
      },
    }),
    reviewCommunityPost: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/community/post/reviewPost`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    fetchDetailedPost: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: `/tenant/community/post/${params.post_id}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    postCommunity: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/community/post/add`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
  })
});

export const {
  useFetchAllCommunityMutation,
  useFetchCommunityCategoryMutation,
  useReviewCommunityPostMutation,
  useFetchDetailedPostMutation,
  usePostCommunityMutation
} = communityApi;
